import { render, staticRenderFns } from "./PlaceBet.vue?vue&type=template&id=277b6de7&scoped=true&"
import script from "./PlaceBet.vue?vue&type=script&lang=js&"
export * from "./PlaceBet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277b6de7",
  null
  
)

export default component.exports